import ApiAcces from "@/shared/services/ApiAcces";
import type Page from "@/shared/models/Page";
import type IIntegrationSetup from "../contracts/IIntegrationSetup";
import type IntegrationSetupCreate from "../models/IntegrationSetupCreate";
import type IntegrationSetupDto from "../models/IntegrationSetup";

export default class IntegrationSetupService
    extends ApiAcces
    implements IIntegrationSetup {
    async GetMySetups(
        pageNumber: number,
        pageSize: number,
    ): Promise<Page<IntegrationSetupDto>> {
        return (
            await this.api.get("api/integrations/setups", {
                params: { pageNumber, pageSize },
            })
        ).data;
    }

    async GetByProvider(providerId: string): Promise<IntegrationSetupDto | null> {
        try {
            return (await this.api.get(`api/integrations/setups/${providerId}`)).data;
        } catch (err) {
            if ((err as { status?: number })?.status === 404) return null;
            throw err;
        }
    }

    async Create(
        integrationSetup: IntegrationSetupCreate,
    ): Promise<IntegrationSetupDto> {
        return (
            await this.api.post("api/integrations/setups", integrationSetup)
        ).data;
    }

    async Update(
        id: string,
        integrationSetup: IntegrationSetupCreate,
    ): Promise<IntegrationSetupDto> {
        return (
            await this.api.patch(`api/integrations/setups/${id}`, integrationSetup)
        ).data;
    }

    async Test(id: string): Promise<void> {
        await this.api.post(`api/integrations/setups/${id}/test`);
    }

    async Delete(id: string): Promise<void> {
        await this.api.delete(`api/integrations/setups/${id}`);
    }
}